import React from 'react';

import PageContext from '../context';

import logo from './img/gw2-logo.png';

import Nav    from './nav';
import MobNav from './mobileNav';

import * as css from './header.module.css';

export default function Header({ nav }) {
    return <PageContext.Consumer>
        {({ gw2Url }) =>
            <header className={ css.header }>
                <h1 className={ css.logo }>
                    <a href={gw2Url}>
                        <img src={logo} alt="Guild Wars 2" />
                    </a>
                </h1>

                <Nav nav={nav}/>
                <MobNav nav={nav}/>
            </header>
        }
    </PageContext.Consumer>;
}
